import type React from 'react';
import { Button } from '../Button';
import { IconClose } from '../Icon';
import Loader from '../Loader';
import { IconWrapper, Label, TagWrapper } from './wrapper';

interface TagProps {
  label: string;
  hideCloseButton?: boolean;
  type?: 'rounded';
  isLoading?: boolean;
  buttonSize?: 'small' | 'tiny';
  icon?: React.ReactNode;
  tone?: 'secondary';
  onClick?: () => void;
  onClose: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const Tag = ({
  label,
  type,
  hideCloseButton,
  isLoading,
  buttonSize,
  icon,
  tone,
  onClick,
  onClose,
}: TagProps) => {
  return (
    <TagWrapper
      $type={type}
      $tone={tone}
      $active={!hideCloseButton}
      $size={buttonSize || 'small'}
      $isClickable={!!onClick}
    >
      {onClick ? (
        <Button $size={buttonSize || 'small'} onClick={onClick}>
          {icon && <IconWrapper>{icon}</IconWrapper>} {label}
        </Button>
      ) : (
        <Label $size={buttonSize || 'small'}>
          {icon && <IconWrapper>{icon}</IconWrapper>} {label}
        </Label>
      )}

      {!hideCloseButton && (
        <Button $size={buttonSize || 'small'} onClick={onClose}>
          {isLoading ? <Loader inline /> : <IconClose />}
        </Button>
      )}
    </TagWrapper>
  );
};

export default Tag;
